import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
//
import { useNavigate } from "react-router";
import { FormattedMessage, useIntl } from "react-intl";
//
import Box from "@mui/material/Box";
import { styled } from "@material-ui/styles";
// component, hooks
import Typography from "@mui/material/Typography";
import useLocaleRoute from "../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../hooks/useModulePublic";
// store
import { StoreContext } from "../../../../store/StoreProvider";
import Act from "../../../../store/actions";
// config,utils
import { ROUTE_PATH, ROUTE_NAME } from "../../../../config/CONSTANTS";
import urls from "../../../../api/project/ApiUrls";
import featureDisplay from "../../../../common/utils/featureDisplay";
import AuthLogo from "../../../../../images/auth_logo/auth_logo.svg";

// style
const StyledBox = styled(
  Box,
  {}
)(({ theme }) => ({
  "&:hover": {
    cursor: "pointer",
  },
}));

const LoginTop = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { user } = state;
  const { locale } = user;
  // local state
  const [test, setTest] = useState(0);
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();

  return (
    <Box>
      <Box display="flex" justifyContent="center" mb={4}>
        <img src={AuthLogo} alt="auth logo" />
      </Box>
      <Box mb={6}>
        <Typography textAlign="center" variant="h6" fontWeight={700}>
          <FormattedMessage
            id="login.welcome.title"
            defaultMessage="歡迎使用社會網絡分析平台"
          />
        </Typography>
      </Box>
    </Box>
  );
};

LoginTop.propTypes = {};

LoginTop.defaultProps = {};

export default LoginTop;
